export default __webpack_public_path__ + "c9fb38cfaf089f380415a079be9761ec.svg";